// extracted by mini-css-extract-plugin
export default {"tableOptions":"uOYzpkpS9VDbQHhAO5mw","optionName":"w4J8qCx3lczYHvX5INB9"};